import { UadListingStatus } from '@aloft/toolkit-shared/lib/syntax/fnma/types';

export function getShouldApplyDateOfSale(listingStatus: UadListingStatus): boolean {
  return listingStatus === 'SettledSale';
}
